import { StyleSheet } from 'aphrodite'

import search from './search'

import ColorBlind from './ColorBlind'

export default {
  search: StyleSheet.create(search),
  ColorBlind
}



// WEBPACK FOOTER //
// ./src/components/Community/Main/Main/style/index.js